import "./style.scss";
import { createRoot } from "react-dom/client";
import Frontend from "./components/Frontend";

document.addEventListener("DOMContentLoaded", () => {
  const dom = document.getElementById("vstr_feedback");
  if (dom) {
    const root = createRoot(dom);
    root.render(<Frontend />);
  }
});
